// src/components/Layout.jsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import './Layout.css';

export default function Layout() {
  const { pathname } = useLocation();
  const isSuperPanel = pathname.startsWith('/super');

  return (
    <div className={`layout${isSuperPanel ? ' layout--super' : ''}`}>
      <Sidebar />
      <main className={`main-content${isSuperPanel ? ' main-content--super' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
}
